// extracted by mini-css-extract-plugin
module.exports = {"ctn":"period_ctn__2JkRL"};